export interface ChannelGroup {
  name: string;
  channelsCount: number;
  updatedAt: string;
}

const channelGroupSeeds = [
  ['News & Current Affairs', 164],
  ['Sports', 142],
  ['Movies', 211],
  ['Series & Drama', 187],
  ['Kids & Family', 96],
  ['Music', 118],
  ['Documentary', 133],
  ['Lifestyle & Food', 89],
  ['Reality & Entertainment', 157],
  ['Science & Technology', 74],
] as const;

export function createChannelGroupSeeds(updatedAt = new Date().toISOString()): ChannelGroup[] {
  return channelGroupSeeds.map(([name, channelsCount]) => ({
    name,
    channelsCount,
    updatedAt,
  }));
}
